import { RcTrans } from '@/components/atoms/RcTrans'
import '@/style/main.scss'
import { useTime } from '@/core/hooks/useTime'
import { useChatRoomDocument } from '@/entity/chat/useChatRoomDocument'
import { useUserAccount } from '@/entity/user/useUserAccount'
import Typography from '@mui/material/Typography'
import { ChatMember } from '@rallycry/social-api-typescript/dist/models'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

export const ChatTypingIndicator = ({ chatId }: { chatId: string }) => {
  const [typing, setTyping] = useState<ChatMember[]>([])
  const { getNow } = useTime()
  const { user } = useUserAccount()
  const { members, data } = useChatRoomDocument({ idOrKey: chatId })

  const uid = user?.id
  useEffect(() => {
    const interval = setInterval(() => {
      const now = getNow()
      const filteredMembers = members.filter(member => {
        const lastTyped = data?.userSyncStatus?.[member.id!]?.lastTyping
        if (!lastTyped) return false
        if (member.id === uid?.toString()) return false // dont show self typing
        const lastTypedTime = moment(lastTyped)
        const timeDiff = moment.duration(now.diff(lastTypedTime)).asSeconds()
        return timeDiff <= 5
      })

      setTyping(filteredMembers)
    }, 1000)
    return () => clearInterval(interval)
  }, [members, data, getNow, uid])

  return (
    <Stack direction='row' alignItems='center' mx={3} mt={1} spacing={1}>
      {typing.length > 0 ? (
        <Stack direction='row' justifyContent='center' width={25}>
          <div className='dot-flashing' />
        </Stack>
      ) : null}

      <Typography
        variant='subtitle2'
        color='text.secondary'
        sx={{
          fontStyle: 'italic'
        }}
      >
        {typing.length > 1 ? (
          <RcTrans
            i18nKey='chat.typing-indicator.multiple'
            tOptions={{ count: typing.length }}
          />
        ) : typing.length === 1 ? (
          <RcTrans
            i18nKey='chat.typing-indicator.single'
            tOptions={{ name: typing[0]?.name }}
          />
        ) : (
          <>&nbsp;</>
        )}
      </Typography>
    </Stack>
  )
}
